import { createSolanaRpc, createSolanaRpcSubscriptions } from '@solana/kit';
import { clusterApiUrl } from '@solana/web3.js';

import { network } from './solana';
import { env } from '../../env';

export type PrivyChain = 'solana:mainnet' | 'solana:devnet';

export const privyChain: PrivyChain =
  env.VITE_PUBLIC_NETWORKS_MODE === 'mainnet'
    ? 'solana:mainnet'
    : 'solana:devnet';

export const endpoints = env.VITE_PUBLIC_SOLANA_RPC?.split(',')
  .map((s) => s.trim())
  .filter(Boolean) ?? [clusterApiUrl(network)];

export const getPrivyRpc = () => {
  const config: Record<string, { rpc: any; rpcSubscriptions: any }> = {};

  config[privyChain] = {
    rpc: createSolanaRpc(endpoints[0]),
    rpcSubscriptions: createSolanaRpcSubscriptions(
      endpoints[0].replace('https://', 'wss://'),
    ),
  };

  return config;
};
